module.exports = __webpack_public_path__ + "img/slide_title.a89dfce8.svg";